import React from 'react';
import {Link} from 'react-router-dom';

export default function Breadcrumbs(props) {
  return (
    props.parents &&
    props.parents.map((p, i) => [
      <span
        key={'breadcrumbs-separator' + i}
        className="kt-subheader__breadcrumbs-separator"
      />,
      <Link
        key={'breadcrumbs-link' + i}
        to={p.path}
        className="kt-subheader__breadcrumbs-link"
      >
        {p.title}
      </Link>,
    ])
  );
}
